
    <mat-card>
      <div *ngFor="let s of categoriesDescription">
        <li>{{s}}</li>
      </div>
    </mat-card>

  